import {
  FieldSchema,
  ObjectFieldSchema,
  Schema,
  isAmountFieldSchema,
  isCheckboxGroupFieldSchema,
  isObjectFieldSchema,
  isRadioFieldSchema,
  isSelectFieldSchema
} from "@generation/core";

export function findFirstFieldInStep(schema: Schema, fieldNameToFind: string): FieldSchema | null {
  for (let fieldName of Object.keys(schema)) {
    const fieldSchema = schema[fieldName];
    if (isObjectFieldSchema(fieldSchema)) {
      const fields = fieldSchema.properties;
      for (let sectionFieldName of Object.keys(fields)) {
        if (fieldNameToFind === sectionFieldName) {
          return fields[sectionFieldName];
        }
      }
    } else if (fieldNameToFind === fieldName) {
      return fieldSchema;
    }
  }
  return null;
}

export function findFirstFieldInSteps(schemas: Schema[], fieldName: string): FieldSchema | null {
  for (let schema of schemas) {
    let foundField = findFirstFieldInStep(schema, fieldName);
    if (foundField) {
      return foundField;
    }
  }
  return null;
}

export function getFieldNamesInStep(schema: Schema): string[] {
  let fieldNames: string[] = [];
  Object.keys(schema).forEach((fieldName) => {
    const fieldSchema = schema[fieldName];
    if (isObjectFieldSchema(fieldSchema)) {
      const fields = fieldSchema.properties;
      fieldNames = [...fieldNames, ...Object.keys(fields)];
    } else {
      fieldNames.push(fieldName);
    }
  });
  return fieldNames;
}

export function getFieldNamesInSteps(schemas: Schema[]): string[] {
  let fields: string[] = [];
  schemas.forEach((schema) => {
    fields = [...fields, ...getFieldNamesInStep(schema)];
  });
  return fields;
}

export function getSectionOfFieldInStep(schema: Schema, fieldName: string): string | undefined {
  for (let sectionName of Object.keys(schema)) {
    const fields = (schema[sectionName] as ObjectFieldSchema).properties;
    for (let fieldNameOfFieldInSection of Object.keys(fields)) {
      if (fieldName === fieldNameOfFieldInSection) {
        return schema[sectionName].label;
      }
    }
  }
  return undefined;
}

export function getSectionOfFieldInSteps(schemas: Schema[], fieldName: string): string {
  for (let schema of schemas) {
    let foundSection = getSectionOfFieldInStep(schema, fieldName);
    if (foundSection) {
      return foundSection;
    }
  }
  throw new Error(`Field ${fieldName} not found in any schema`);
}

export function getDisplayNameOfSubmittedValue(
  field: FieldSchema,
  submittedValue: string
): string | undefined {
  if (isSelectFieldSchema(field)) {
    return field.options?.filter((option) => option.value === submittedValue)[0].label;
  } else if (isRadioFieldSchema(field)) {
    return field.options?.filter((option) => option.value === submittedValue)[0].label;
  } else if (isCheckboxGroupFieldSchema(field)) {
    return field.options?.filter((option) => option.value === submittedValue)[0].label;
  } else if (isAmountFieldSchema(field)) {
    return field.overview?.beforeText?.text
      ? field.overview.beforeText?.text + submittedValue
      : submittedValue;
  }
  return submittedValue;
}
